module.exports = __webpack_public_path__ + "img/mythimna-separata.98eb371f.jpg";